var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2875)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_2875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5064 22.8022C28.8106 22.8022 32.1583 19.3069 32.1583 15.0171C32.1583 10.7273 28.6511 7.39087 24.3469 7.39087C20.0428 7.39087 16.6951 10.8862 16.6951 15.0171C16.6951 19.3069 20.2022 22.8022 24.5064 22.8022ZM24.3469 10.5685C24.5064 10.5685 24.5064 10.5685 24.3469 10.5685C26.8976 10.5685 28.97 12.6339 28.97 15.176C28.97 17.7181 26.8976 19.6246 24.3469 19.6246C21.7963 19.6246 19.8833 17.5592 19.8833 15.176C19.8833 12.6339 21.9557 10.5685 24.3469 10.5685Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0997 21.8487C45.0708 19.1477 41.0855 17.7178 36.9407 17.8767H35.6654C35.3465 19.1477 34.8683 20.2599 34.2306 21.2132C35.1871 21.0543 35.9842 21.0543 36.9407 21.0543C39.9696 20.8954 42.9984 21.8487 45.3897 23.5964V35.0357H48.5779V22.3253L48.0997 21.8487Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2741 7.70814C34.0712 5.80158 36.303 4.8483 38.3754 5.6427C40.2884 6.4371 41.2449 8.66141 40.4478 10.7269C39.8101 12.1568 38.3754 13.1101 36.9407 13.1101C36.6219 13.1101 36.1436 13.1101 35.8248 12.9512C35.9842 13.7456 35.9842 14.54 35.9842 15.1755V16.1288C36.303 16.1288 36.6219 16.2876 36.9407 16.2876C40.926 16.2876 44.1143 13.1101 44.1143 9.29693C44.1143 5.32494 40.926 2.14734 37.1001 2.14734C34.5495 2.14734 32.3177 3.41838 31.0423 5.6427C31.8394 6.11934 32.6365 6.75486 33.2741 7.70814Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1009 21.3721C14.4633 20.4189 13.985 19.3067 13.6662 18.0357H12.3909C8.2461 17.8768 4.26073 19.3067 1.23186 21.8488L0.753613 22.3254V35.0358H3.9419V23.5965C6.49254 21.8488 9.362 20.8955 12.3909 21.0544C13.3474 21.0544 14.3038 21.2133 15.1009 21.3721Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3909 16.1294C12.7097 16.1294 13.0285 16.1294 13.3474 15.9705V15.0172C13.3474 14.2228 13.3474 13.4284 13.5068 12.7929C13.1879 12.9518 12.7097 12.9518 12.3909 12.9518C10.3185 12.9518 8.56493 11.2041 8.56493 9.13868C8.56493 7.07324 10.3185 5.32556 12.3909 5.32556C13.985 5.32556 15.4198 6.27884 16.0574 7.70876C16.6951 6.91436 17.6516 6.11996 18.4486 5.48444C16.3762 2.14796 12.072 1.0358 8.72434 3.10124C5.37664 5.16668 4.26074 9.45644 6.33313 12.7929C7.60844 14.8584 9.84025 16.1294 12.3909 16.1294Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5784 31.3816L37.2595 30.905C34.0713 27.4096 29.6076 25.3442 24.8252 25.5031C20.0428 25.3442 15.4198 27.4096 12.2315 30.905L11.9126 31.3816V43.4565C11.9126 44.8864 13.0285 46.1574 14.6227 46.1574H35.0277C36.4625 46.1574 37.7378 44.8864 37.7378 43.4565V31.3816H37.5784ZM34.3901 42.9798H15.1009V32.4938C17.6516 29.9517 21.1587 28.6807 24.8252 28.6807C28.3323 28.5218 31.8394 29.9517 34.3901 32.4938V42.9798Z",
    fill: "#0D5C63"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.165771)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_2875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 44.2105,
    fill: "white",
    transform: "translate(0.665771 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.6cbcec2e279ebd89eabe1884ffe5ea82.svg";
export { ForwardRef as ReactComponent };